// src/hook.ts
import * as React from "react";
var useMemoOnce = (fn) => {
  const [value] = React.useState(fn);
  return value;
};
export {
  useMemoOnce
};
